import React from 'react';
import ReusableTable from '../Common/BaseTable';
import '../../styles/Dashboard/EmailCampaignTable.css'

const EmailCampaignView = () => {
  const data = [
    {
      id: 1,
      campaignDate: 'Jun 27, 2023',
      name: 'Unlock the power of the TikTok Ads with our trial automation email',
      listName: 'Winback email',
      marketingTime: 'Jun 27, 2023',
      recipients: 20856,
      bounces: 58,
      opened: 10569,
      clickRate: '5.15%',
      totalClicks: 1558
    },
    {
      id: 2,
      campaignDate: 'Aug 5, 2023',
      name: 'Join our live webinar now',
      listName: 'Refill sequence',
      marketingTime: 'Aug 5, 2023',
      recipients: 589,
      bounces: 6,
      opened: 256,
      clickRate: '2%',
      totalClicks: 300
    },
    {
      id: 3,
      campaignDate: 'Sept 16, 2023',
      name: 'Your feedback matters Hubspot automation',
      listName: 'Sunset email',
      marketingTime: 'Sept 16, 2023',
      recipients: 2892,
      bounces: 25,
      opened: 800,
      clickRate: '50%',
      totalClicks: 1500
    },
    {
      id: 4,
      campaignDate: 'Jun 18, 2024',
      name: 'Unlock the power LinkedIn pages',
      listName: 'Subscribers',
      marketingTime: 'Jun 18, 2024',
      recipients: 598,
      bounces: 65,
      opened: 100,
      clickRate: '20%',
      totalClicks: 258
    },
    {
      id: 5,
      campaignDate: 'Oct 27, 2024',
      name: 'Experience the future with our 3D Email',
      listName: 'Abandon cart',
      marketingTime: 'Oct 27, 2024',
      recipients: 8659,
      bounces: 503,
      opened: 5236,
      clickRate: '64%',
      totalClicks: 2569
    }
  ];

  const columns = [
    {
      accessorKey: 'campaignDate',
      header: 'Campaign Date',
    },
    {
      accessorKey: 'name',
      header: 'Campaign name',
    },
    {
      accessorKey: 'listName',
      header: 'Campaign list name',
    },
    {
      accessorKey: 'marketingTime',
      header: 'Marketing email created',
    },
    {
      accessorKey: 'recipients',
      header: 'Recipients',
      cell: ({ row }) => row.original.recipients.toLocaleString(),
    },
    {
      accessorKey: 'bounces',
      header: 'Bounces',
      cell: ({ row }) => (
        <span className="text-danger">{row.original.bounces}</span>
      ),
    },
    {
      accessorKey: 'opened',
      header: 'Opened',
      cell: ({ row }) => row.original.opened.toLocaleString(),
    },
    {
      accessorKey: 'clickRate',
      header: 'Campaign click rate',
    },
    {
      accessorKey: 'totalClicks',
      header: 'Campaign total clicks',
      cell: ({ row }) => row.original.totalClicks.toLocaleString(),
    },
  ];

  const handleSearch = (value) => {
    console.log('Searching:', value);
    // Implement search logic
  };

  const handleDelete = (selectedIds) => {
    console.log('Deleting:', selectedIds);
    // Implement delete logic
  };

  const handleDuplicate = (selectedIds) => {
    console.log('Duplicating:', selectedIds);
    // Implement duplicate logic
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Email Campaigns</h1>
        <button className="btn btn-danger create-email">
          Create new email
        </button>
      </div>

      <div className="email-campaign-container">
        <div className="header-section">
          <div className="d-flex align-items-start gap-3 mb-4">
            <div className="campaign-icon">
              <img 
                src="/mailchimp.svg" 
                alt="Campaign Icon" 
                className="rounded-circle"
                width="48"
                height="48"
              />
            </div>
            <div>
            
              <h2 className="mb-1">Track your email Campaigns</h2>
              <small className="text-muted">
                Top search categories reveal audience interests and keywords, helping
                optimize email content and subject lines in your Mailchimp campaigns.
              </small>
            </div>
          </div>
        </div>

        <ReusableTable
          columns={columns}
          data={data}
          onSearch={handleSearch}
          onDelete={handleDelete}
          onDuplicate={handleDuplicate}
          gridView={false}
        />
      </div>
    </>
  );
};

export default EmailCampaignView;